"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ui_1 = require("@aperza/ui");
var util_1 = require("@aperza/util");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var prop_types_1 = __importDefault(require("prop-types"));
var react_1 = __importDefault(require("react"));
var NavBarItem = /** @class */ (function (_super) {
    __extends(NavBarItem, _super);
    function NavBarItem(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            showSubMenu: true,
        };
        return _this;
    }
    NavBarItem.prototype.onMouseOver = function (e) {
        if (!this.props.disabled && this.props.onMouseOver) {
            this.props.onMouseOver();
            e.preventDefault();
        }
    };
    NavBarItem.prototype.render = function () {
        var _a = this.props, title = _a.title, shortTitle = _a.shortTitle, imageUrl = _a.imageUrl, url = _a.url, className = _a.className, icon = _a.icon, openOnNewTab = _a.openOnNewTab, showExternalLink = _a.showExternalLink, disabled = _a.disabled;
        var showSubMenu = this.state.showSubMenu;
        var display = 'none';
        if (showSubMenu) {
            display = 'block';
        }
        var selectedShortTitle = shortTitle ? shortTitle : title;
        var href = util_1.AppConfigService.getHref();
        var selected = href.startsWith(url || '');
        var renderLogo = function (icon) {
            if (typeof icon === 'string' || icon instanceof String) {
                return react_1.default.createElement("div", { className: "naviLinkLogo " + icon });
            }
            else {
                return (react_1.default.createElement("div", { style: { marginRight: '4px' } },
                    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, __assign({}, icon))));
            }
        };
        return (react_1.default.createElement("div", { onMouseOver: this.onMouseOver.bind(this) },
            react_1.default.createElement("a", { className: "naviLink " + (className ? className : '') + " " + (selected ? 'selected' : '') + " " + (disabled ? 'aw-disabled' : ''), href: disabled ? '#' : url, target: openOnNewTab ? '_blank' : '_self' },
                icon && renderLogo(icon),
                react_1.default.createElement(ui_1.WebMediaQuery, { desktopOnly: true }, title),
                react_1.default.createElement(ui_1.WebMediaQuery, { mobileOnly: true }, selectedShortTitle),
                showExternalLink && react_1.default.createElement("div", { className: "external-link" }))));
    };
    NavBarItem.propTypes = {
        title: prop_types_1.default.any.isRequired,
        shortTitle: prop_types_1.default.any,
        icon: prop_types_1.default.any,
        url: prop_types_1.default.string,
        openOnNewTab: prop_types_1.default.bool,
        showExternalLink: prop_types_1.default.bool,
        className: prop_types_1.default.string,
        onMouseOver: prop_types_1.default.func,
        disabled: prop_types_1.default.bool,
    };
    return NavBarItem;
}(react_1.default.Component));
exports.default = NavBarItem;
